import axios from "@/api/axios";
import store from "@/store";
import _ from "lodash";
import qs from "qs";

// 공지사항리스트
const getPlayerNoticelist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticelistcnt: 0,
    noticelist: [],
  };
  const options = {
    method: "GET",
    url: "/customer/noticeweblist",
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data, response.data.code);
      }
    });
  } catch (err) {
    console.error("getPlayerNoticelist", err);
    result(false, err, 400);
  }
};

// 공지사항상세보기
const getPlayerNoticeview = async (noticeno, param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticeview: [
      {
        type: "",
        title: "",
        date: "",
        cnt: "",
        contents: "",
      },
    ],
    next_post: {},
    prev_post: {},
  };

  const options = {
    method: "GET",
    url: "/customer/noticewebview/" + noticeno,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("getPlayerNoticeview", err);
    result(false, err);
  }
};

// 공지사항등록/수정
const getPlayerNoticeWrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticewebwrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getPlayerNoticeModify = async (formData, noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticewebwrite/" + noticeno,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};
const getPlayerNoticeDelete = async (noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/noticewebdelete/" + noticeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

// 공지사항리스트
const getOwnerNoticelist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticelistcnt: 0,
    noticelist: [],
  };
  const options = {
    method: "GET",
    url: "/customer/noticeshoplist",
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    console.error("getPlayerNoticelist", err);
    result(false, err, 400);
  }
};

// 공지사항상세보기
const getOwnerNoticeview = async (noticeno, param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticeview: [
      {
        type: "",
        title: "",
        date: "",
        cnt: "",
        contents: "",
      },
    ],
    next_post: {},
    prev_post: {},
  };

  const options = {
    method: "GET",
    url: "/customer/noticeshopview/" + noticeno,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    console.error("getPlayerNoticeview", err);
    result(false, err);
  }
};

// 공지사항등록/수정
const getOwnerNoticeWrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticeshopwrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getOwnerNoticeModify = async (formData, noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticeshopwrite/" + noticeno,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};
const getOwnerNoticeDelete = async (noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/noticeshopdelete/" + noticeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

// 공지사항리스트
const getAppNoticelist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticelistcnt: 0,
    noticelist: [],
  };
  const options = {
    method: "GET",
    url: "/customer/noticeapplist",
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};

// 공지사항상세보기
const getAppNoticeview = async (noticeno, param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    noticeview: [
      {
        type: "",
        title: "",
        date: "",
        cnt: "",
        contents: "",
      },
    ],
    next_post: {},
    prev_post: {},
  };

  const options = {
    method: "GET",
    url: "/customer/noticeappview/" + noticeno,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};

// 공지사항등록/수정
const getAppNoticeWrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticeappwrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getAppNoticeModify = async (formData, noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/noticeappwrite/" + noticeno,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getAppNoticeDelete = async (noticeno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/noticeappdelete/" + noticeno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
// 공지사항리스트
const getResourceslist = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    resourceslistcnt: 0,
    resourceslist: [],
  };
  const options = {
    method: "GET",
    url: "/customer/resourceslist",
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

// 공지사항상세보기
const getResourcesView = async (resourcesno, param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    resourcesview: [
      {
        cnt: null,
        contents: null,
        date: null,
        filename: null,
        nextno: null,
        nexttitle: null,
        path: null,
        prevno: null,
        prevtitle: null,
        status: null,
        title: null,
        topstatus: null,
        type: null,
        writer: null,
      },
    ],
    next_post: {},
    prev_post: {},
  };

  const options = {
    method: "GET",
    url: "/customer/resourcesview/" + resourcesno,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};

// 공지사항등록/수정
const getResourcesWrite = async (formData, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/resourceswrite",
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getResourcesModify = async (formData, resourcesno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "POST",
    url: "/customer/resourceswrite/" + resourcesno,
    headers: { "Content-Type": "multipart/form-data" },
    data: formData,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};

const getResourcesDelete = async (resourcesno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/resourcesdelete/" + resourcesno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
// 공지사항리스트
const getInquiryList = async (param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    inquirylistcnt: 0,
    inquirylist: [],
  };
  const options = {
    method: "GET",
    url: "/customer/inquirylist",
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
      pageno: param.pageno,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData, response.data.code);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message, response.data.code);
      }
    });
  } catch (err) {
    result(false, err, 400);
  }
};

// 공지사항상세보기
const getInquiryView = async (inquiryno, param, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
    inquiryview: [],
    next_post: {},
    prev_post: {},
  };

  const options = {
    method: "GET",
    url: "/customer/inquiryview/" + inquiryno,
    params: {
      searchtype: param.searchtype,
      searchname: param.searchname,
    },
  };

  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getInquiryDelete = async (inquiryno, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "DELETE",
    url: "/postact/inquirydelete/" + inquiryno,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data.message);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
const getInquiryStatus = async (inquiryno, viewflag, result) => {
  let finalData = {
    code: 200,
    message: "Ok",
  };

  const options = {
    method: "PUT",
    url: "/postact/inquiryedit/" + inquiryno + "/" + viewflag,
  };
  try {
    await axios(options).then((response) => {
      if (response.data.code === 200) {
        finalData = _.merge(finalData, response.data);
        result(true, finalData);
      } else {
        console.error(response.data.code, response.data.message);
        result(false, response.data);
      }
    });
  } catch (err) {
    result(false, err);
  }
};
export default {
  getPlayerNoticelist,
  getPlayerNoticeview,
  getPlayerNoticeWrite,
  getPlayerNoticeModify,
  getPlayerNoticeDelete,
  getOwnerNoticelist,
  getOwnerNoticeview,
  getOwnerNoticeWrite,
  getOwnerNoticeModify,
  getOwnerNoticeDelete,
  getAppNoticelist,
  getAppNoticeview,
  getAppNoticeWrite,
  getAppNoticeModify,
  getAppNoticeDelete,
  getResourceslist,
  getResourcesView,
  getResourcesWrite,
  getResourcesModify,
  getResourcesDelete,
  getInquiryList,
  getInquiryView,
  getInquiryDelete,
  getInquiryStatus,
};
